<script lang="ts">
  import type { Snippet } from "svelte";
  import { getWorkflow } from "../../lib/workflow/workflowLib.svelte";

  let {
    back = true,
    class:className = "",
    children,
  }: {
    back?: boolean;
    class?: string;
    children: Snippet;
  } = $props();

  const workflow = getWorkflow();
</script>

<div class="floating-footer {className}">
  {#if back}
    <button class="btn btn-ghost" type="button" onclick={() => workflow.prevStep()}>Back</button>
  {/if}
  {@render children()}
</div>
